import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output, ViewRef
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {Session} from "../../services/Session";
import {v4 as uuid} from 'uuid';
import {NgxScrollEventDirective} from "../../directives/ngx-scroll-event.directive";
import {SafeHtmlPipe} from "../../pipes/SafeHtmlPipe";
import {FormsModule} from "@angular/forms";
import {CustomDatepicker} from "../../directives/customDatepicker";
import {ModelBasedNumeral} from "../../directives/model-numeral";
import {ClickOutsideDirective} from "../../directives/click.outside";
import { MatIcon } from '@angular/material/icon';
import {DragDropModule, CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";

declare let _: any;
declare let jQuery: any;

@Component({
  selector: 'app-tracker-paginated-table',
  standalone: true,
  imports: [CommonModule, FormsModule, ModelBasedNumeral, NgxScrollEventDirective, SafeHtmlPipe, CustomDatepicker, ClickOutsideDirective,MatIcon,DragDropModule],
  templateUrl: './tracker-paginated-table.component.html',
  styleUrl: './tracker-paginated-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrackerPaginatedTableComponent implements OnInit, OnDestroy {
  eventNames: Array<string> = [];
  id: string;
  selector: string;
  height: string;
  data: Array<any>;
  columns: Array<any> = [];
  searchString: string;
  showSearchIcon = true;
  showSearch = false;
  companyCurrency: string;

  /* Fields related to badge input popup */
  displayWidget: boolean;
  displayDropdown = false;
  selectedRow: any = {};
  selectedCol: any = {};
  searchEntries: Array<any> = [];
  dropSearchString: string;
  displayPaymentWidget: boolean;

  @Input() emptyText: string;

  @Input() widgetLoader: boolean;

  @Input() set externalUsersData(data) {
    this.searchEntries = [...data];
    this.selectedCol.data = [...data];
  }

  @Input()
  set setObj(obj: any) {
    const base = this;
    setTimeout(() => {
      jQuery(`#${this.id}`).find('*').off();
      base.data = [...obj.rows] || [];
      base.columns = [...obj.columns] || [];
      const options = {...obj.options} || {};
      base.height = options.height || '200px';
      base.selector = options.selectorString || 'id';
      if (options.showSearch != undefined) {
        base.showSearch = options.showSearch;
      }
      base.searchString = options.searchString;
      if (base.searchString) {
        base.showSearchIcon = false;
      }
      if (base.selectedRow && !_.isEmpty(base.selectedRow)) {
        base.updateSelectedRow();
      }
      base.renderTable();
      base.widgetLoader = false;
      base.detectChanges();
    });
  }

  @Output()
  onRowClick: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onMouseOver: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onMouseOut: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onRowAction: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onRowSelect: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onScroll: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onRemoveSearch: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onSort: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onInputSearchSelection: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onDropdownSelection: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onInputBlur: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onStatusMove: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onPayment: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onReviewerChange: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onExternalUsers: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  orderChanged: EventEmitter<any> = new EventEmitter<any>();
 

  @Input() reorderMode = false;
  // When the parent wires (onRowClick) so the whole row navigates, set this so
  // the row shows a pointer cursor. Off by default: this table is shared, and
  // rows that are not clickable must keep the default cursor (CU-868krk6ab #5).
  @Input() clickableRows = false;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
  }

  getSortType(column) {
    if (!column.sortType) {
      column.sortType = 'asc';
    } else if (column.sortType == 'asc') {
      column.sortType = 'desc';
    } else if (column.sortType == 'desc') {
      column.sortType = 'asc';
    }
    return column.sortType;
  }

  renderTable() {
    const base = this;

    const tableSelector = jQuery(`#${this.id} table`);

    tableSelector.on('click', 'thead th', function(e) {
      if (e.target.type != 'checkbox' && jQuery(this).attr('sortable') == 'true') {
        e && e.preventDefault();
        e && e.stopImmediatePropagation();
        const column: any = base.columns[this.cellIndex];
        const obj = {
          column: column.name,
          order: base.getSortType(column),
          searchString: base.searchString
        };
        base.handleOnSort(obj);
      }
    });

    tableSelector.on('mouseover', 'thead th', function(e) {
      const preRow = _.find(base.data, {isEditable: true});
      if (preRow) {
        preRow.isEditable = false;
      }
      if (preRow && preRow.showTextArea) {
        preRow.showTextArea = false;
      }
    });

    tableSelector.on('change', 'tbody tr input.checkbox', function(e) {
      e && e.preventDefault();
      e && e.stopPropagation();
      const id = jQuery(this).closest('tr').attr('id');
      const row = _.find(base.data, function(obj) {
        return obj[base.selector] == id;
      });
      base.handleOnSelect(row);
    });

    tableSelector.on('click', 'thead tr input.global-checkbox', function(e) {
      if (jQuery(this).is(':checked')) {
        base.handleOnSelect(true);
      } else {
        base.handleOnSelect(false);
      }
    });


    tableSelector.on('mouseover', 'tbody tr', function(e) {
      const id = jQuery(this).closest('tr').attr('id');
      const row = _.find(base.data, function(obj) {
        return obj[base.selector] == id;
      });
      jQuery(e.currentTarget).find('.show-on-hover').css('display', 'block');
      if (row) {
        if (row.hasOwnProperty('isEditable')) {
          const preRow = _.find(base.data, {isEditable: true});
          if (preRow) {
            preRow.isEditable = false;
          }
          row.isEditable = true;
        }
      }
      base.detectChanges();
    });

    tableSelector.on('mouseleave', 'tbody tr', function(e) {
      jQuery('.pika-single.is-hidden').remove();
      jQuery(e.currentTarget).find('.show-on-hover').css('display', 'none');
    });

    tableSelector.on('click', 'tbody tr td', function(e) {
      // Ignore clicks on interactive cell controls (status editing, inputs) so they don't also trigger a row-open
      if (jQuery(e.target).closest('.status-cell, input, select, textarea').length) {
        return;
      }
      const tr = jQuery(this).closest('tr');
      const id = tr.attr('id') || tr.attr('data-id');
      const row = _.find(base.data, function(obj) {
        return obj[base.selector] == id;
      });
      base.handleOnClick(row);
    });

    tableSelector.on('click', 'tbody tr a', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const action = jQuery(this).data('action');
      const tr = jQuery(this).closest('tr');
      const id = tr.attr('id') || tr.attr('data-id');
      const row = _.find(base.data, function(obj) {
        return obj[base.selector] == id;
      });
      if (!row) {
        return;
      }
      row.action = action;
      if (action == 'delete') {
        base.handleOnAction(row);
      } else if (action == 'verify') {
        jQuery(this).hide();
      } else {
        base.handleOnAction(row);
      }
    });

  }

  ngOnInit() {
    this.id = uuid();
    this.companyCurrency = Session.getCurrentCompanyCurrency();
  }

  handleScroll($event) {
    this.onScroll.next($event);
  }

  // Keyed on the row selector so data refreshes reuse row DOM instead of recreating it mid-interaction.
  trackRow = (index: number, obj: any) => {
    return (obj && obj[this.selector] != null) ? obj[this.selector] : index;
  }

  handleOnClick(obj) {
    this.onRowClick.next(obj);
  }

  handleOnAction(obj) {
    this.onRowAction.next(obj);
  }

  handleOnSelect(obj) {
    this.onRowSelect.next(obj);
  }

  handleMouseOver(obj) {
    this.onMouseOver.next(obj);
  }

  handleMouseOut() {
    this.onMouseOut.next({});
  }

  handleAddRow() {
    this['onAddRow'].next({});
  }

  handleOnSort(obj) {
    this.onSort.next(obj);
  }

  ngOnDestroy() {
    jQuery(`#${this.id}`).find('*').off();
  }

  propagateSelection($event) {
    this.onInputSearchSelection.next($event);
  }

  propagateDropdownSelection($event) {
    this.onDropdownSelection.next($event);
  }

  propagateNextStatus(column, $event) {
    if (column.type !== 'subStatusDropDown') {
      this.onStatusMove.next($event);
    }
  }

  resetAll(selectedRow) {
    const base = this;
    selectedRow.isEditable = true;
    _.each(this.data, function(obj) {
      if (obj[base.selector] !== selectedRow[base.selector]) {
        obj.isEditable = false;
      } else {
        obj.isEditable = true;
      }
    });
  }

  getSubStatusChange(column, current, obj) {
    let updated = [];
    if (current === 'Not Done') {
      updated = [...column.data];
    } else {
      const statuses = [...column[obj.status.id]];
      for (const i in statuses) {
        statuses[i] = {...statuses[i], key: statuses[i].id, value: statuses[i].status};
        updated = [...updated, statuses[i]];
      }
    }
    return updated;
  }

  onInputChange(obj, col, type?) {
    this.onInputBlur.next({
      row: obj,
      column: col
    });
    if (type && type === 'textArea') {
      obj.showTextArea = false;
    }
  }

  onResetValue(obj, col, type?) {
    obj.resetValue = true;
    this.onInputBlur.next({
      row: obj,
      column: col
    });
  }

  handleDateChange(event, obj, column) {
    obj[column] = event;
    this.onInputBlur.next({
      row: obj,
      column: column
    });
  }

  onMouseClick(e: MouseEvent, row, column) {
    // An editable cell opens an inline editor on click; stop the click bubbling
    // to the row-click handler, which would navigate away and close the editor
    // immediately (CU-868kqg2w5, the organizer inline status dropdown).
    // Deliberately scoped to columns marked editable:true (the organizer Status
    // column is one) to keep the blast radius off other tables per the product
    // decision; columns that omit editable are intentionally left as they were.
    if (e && column && column.editable === true) {
      e.stopPropagation();
    }
    const base = this;
    this.dropSearchString = '';
    this.selectedRow = row;
    this.selectedCol = _.cloneDeep(column);

    if (column.type === 'subStatusDropDown') {
      this.searchEntries = this.getSubStatusChange(column.data, '', row);
    } else if (column['conditional-status'] || column['tasks-status']) {
      const entries = column.data[row.type].typeStatus;
      this.searchEntries = [];
      for (const i in entries) {
        const statusObj: any = {};
        statusObj.id = entries[i].id;
        statusObj.name = entries[i].status;
        this.searchEntries.push(statusObj);
      }
    } else if (column['conditional-column']) {
      const conditionOn = row[column['row-condition']];
      const entries = column.data[conditionOn];
      this.searchEntries = _.map(entries, function(entry) {
        return {
          id: entry.id,
          name: entry[column.displayKey]
        };
      }) || [];
    } else if (column.type === 'badge-input-search' && column.dropdownData === 'externalUsers') {
      this.searchEntries = [];
      this.widgetLoader = true;
      base.onExternalUsers.emit(row);
    } else {
      if (column.type !== 'reviewer') {
        this.searchEntries = _.cloneDeep(column.data) || [];
      }
    }

    if (column.type == 'reviewer') {
      this.onReviewerChange.emit({col: column, row});
    }

    if (column.type !== 'reviewer') {
      if (column.type === 'payment') {
        this.selectedCol.data.applyObject.reference_number = this.selectedRow.numberForExcel;
        this.selectedCol.data.applyObject.amount = this.selectedRow.amount_value;
        // this.selectedCol.data.applyObject.payment_date = this.selectedRow.due_date;
        this.setupPaymentWidget(e);
      } else {
        const popupHeight = 250, // hardcode these values
          popupWidth = 250;    // or compute them dynamically

        let popupXPosition,
          popupYPosition;

        if (e.clientX + popupWidth > window.innerWidth) {
          popupXPosition = e.pageX - popupWidth;
        } else {
          popupXPosition = e.pageX;
        }

        if (e.clientY + popupHeight > window.innerHeight) {
          popupYPosition = e.pageY - popupHeight;
        } else {
          popupYPosition = e.pageY;
        }

        if (base.selectedCol.view && base.selectedCol.view === 'inReveal') {
          popupYPosition = popupYPosition - 55;
          popupXPosition = popupXPosition - 140;
        }
        this.selectedCol.editable = this.selectedCol.editable === undefined ? true : this.selectedCol.editable;
        this.displayDropdown = true;
        this.displayWidget = false;
        setTimeout(() => {
          this.displayWidget = true;
          this.detectChanges();
        }, 10);
        setTimeout(() => {
          jQuery('#widget-container').css({
            top: popupYPosition,
            left: popupXPosition,
            position: 'absolute',
            padding: '5px'
          });
        }, 20);
      }
    }
  }

  setupPaymentWidget(e: MouseEvent) {
    const popupHeight = 300, // hardcode these values
      popupWidth = 300;    // or compute them dynamically

    let popupXPosition,
      popupYPosition;

    if (e.clientX + popupWidth > window.innerWidth) {
      popupXPosition = e.pageX - popupWidth;
    } else {
      popupXPosition = e.pageX;
    }

    if (e.clientY + popupHeight > window.innerHeight) {
      popupYPosition = e.pageY - popupHeight;
    } else {
      popupYPosition = e.pageY;
    }

    this.selectedCol.editable = this.selectedCol.editable === undefined ? true : this.selectedCol.editable;
    this.displayPaymentWidget = false;
    setTimeout(() => {
      this.displayPaymentWidget = true;
      this.detectChanges();
    }, 10);
    setTimeout(() => {
      jQuery('#payment-widget-container').css({
        top: popupYPosition,
        left: popupXPosition,
        position: 'absolute',
        padding: '5px'
      });
    }, 20);
  }

  removeItem($event, entryObj) {
    $event && $event.preventDefault();
    $event && $event.stopImmediatePropagation();
    if (this.selectedCol['multi-dropdown'] && this.selectedCol.name === 'taskAssignees') {
      let entries = this.selectedRow[this.selectedCol.name] || [];
      const index = _.findIndex(entries, {id: entryObj.id});
      const assignedToIndex = _.findIndex(entries, {id: entryObj.assignedTo});
      if (index !== -1) {
        entries = entries.filter((entry, idx) => {
          return index != idx;
        });
      } else if (assignedToIndex !== -1) {
        entries = entries.filter((entry, idx) => {
          return assignedToIndex != idx;
        });
      }
      this.selectedRow[this.selectedCol.name] = entries;
    }
    this.propagateSelection({
      entry: entryObj,
      row: this.selectedRow,
      column: this.selectedCol.name,
      multiDropdown: this.selectedCol['multi-dropdown'],
      type: 'remove'
    });
    if (!this.selectedCol['multi-dropdown']) {
      this.resetSearchEntries();
    }
  }

  resetSearchEntries() {
    const base = this;
    setTimeout(() => {
      base.searchEntries = [];
      base.searchString = '';
      base.displayDropdown = false;
      base.displayWidget = false;
      base.detectChanges();
    }, 200);
  }

  filterEntries($event) {
    const base = this;
    const searchString = $event.target.value || '';
    if (searchString) {
      this.searchEntries = _.filter(this.selectedCol.data, function(obj) {
        return obj.name.toLowerCase().indexOf(searchString.toLowerCase()) != -1;
      });
    } else {
      this.searchEntries = _.cloneDeep(this.selectedCol.data);
    }
  }

  triggerOnSelect($event, entry) {
    if (this.selectedCol['multi-dropdown'] && ((this.selectedCol.name === 'taskAssignees') || (this.selectedCol.name === 'taskAsignees') || (this.selectedCol.name === 'assignees'))) {
      if (this.checkDuplicate(entry)) {
        return;
      } else {
        this.selectedRow[this.selectedCol.name] = [...this.selectedRow[this.selectedCol.name], entry];
      }
    } else if (this.selectedCol['multi-dropdown'] && this.selectedCol.name === 'users') {
      if (this.checkDuplicateById(entry)) {
        return;
      } else {
        this.selectedRow[this.selectedCol.name] = [...this.selectedRow[this.selectedCol.name], entry];
      }
    } else if (this.selectedCol['multi-dropdown'] && this.selectedCol.name === 'toDoAssignee') {
      if (this.checkDuplicateByAssignedTo(entry)) {
        return;
      } else {
        this.selectedRow[this.selectedCol.name] = [...this.selectedRow[this.selectedCol.name], entry];
      }
    } else if (this.selectedCol['multi-dropdown'] && this.selectedCol.name === 'label') {
      if (this.checkDuplicateById(entry)) {
        return;
      }
    } else if(this.selectedCol['action-type']){
      this.selectedRow[this.selectedCol.name] = '';
    } else {
      this.selectedRow[this.selectedCol.name] = entry;
    }
    this.propagateSelection({
      entry: entry,
      row: this.selectedRow,
      column: this.selectedCol.name,
      multiDropdown: this.selectedCol['multi-dropdown'],
      type: 'add'
    });
    if (!this.selectedCol['multi-dropdown']) {
      this.resetSearchEntries();
    }
  }

  checkDuplicate(entry) {
    let isduplicate = false;
    _.forEach(this.selectedRow[this.selectedCol.name], function(obj) {
      if (obj.assignedTo === entry.id) {
        isduplicate = true;
      }
    });
    return isduplicate;
  }

  checkDuplicateById(entry) {
    let isduplicate = false;
    _.forEach(this.selectedRow[this.selectedCol.name], function(obj) {
      if (obj.id === entry.id) {
        isduplicate = true;
      }
    });
    return isduplicate;
  }

  checkDuplicateByAssignedTo(entry) {
    let isduplicate = false;
    _.forEach(this.selectedRow[this.selectedCol.name], function(obj) {
      if (obj.assignedTo === entry.assignedTo) {
        isduplicate = true;
      }
    });
    return isduplicate;
  }

  closeContainer() {
    this.displayWidget = false;
    this.dropSearchString = '';
    this.selectedRow = {};
    this.selectedCol = {};
    this.detectChanges();
  }

  moveNext(column, obj) {
    this.propagateNextStatus(column, {
      row: obj,
      column: column.name
    });
  }

  updateSelectedRow() {
    const base = this;
    _.forEach(base.data, function(value) {
      if (base.selectedRow[base.selector] === value[base.selector]) {
        base.selectedRow = value;
      }
    });
  }

  applyPayment() {
    const obj = {col: this.selectedCol, row: this.selectedRow};
    this.onPayment.next(obj);
    this.displayPaymentWidget = false;
  }

  setDate(date) {
    this.selectedCol.data.applyObject.payment_date = date;
  }

  validate() {
    const values = this.selectedCol.data.applyObject;
    if (values.payment_method && values.bank_account_id && values.reference_number && values.payment_date &&
      (values.amount || (values.amount == 0 && this.selectedRow.amount_due_number == 0))) {
      return true;
    }
    return false;
  }

  closePaymentContainer() {
    this.displayPaymentWidget = false;
    this.selectedRow = {};
    this.selectedCol = {};
    this.detectChanges();
  }

  doNothing($event) {
    $event && $event.preventDefault();
    $event && $event.stopImmediatePropagation();
  }

  setStringSizeLimit(name) {
    if (name && name.length > 20) {
      return name.substring(0, 20) + '....';
    } else {
      return name;
    }
  }

  enableTextArea(obj) {
    obj.showTextArea = true;
  }

  detectChanges(): void {
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  dropRow(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex === event.currentIndex) {
      return;
    }
    const updated = [...this.data];
    moveItemInArray(updated, event.previousIndex, event.currentIndex);
    this.data = updated;
    this.orderChanged.emit(updated);
  }

}
